// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import{getAuth} from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyAgMrnKagUYhq8iGAxi-lu79cAb9KHB_Ro",
    authDomain: "pro-tools-d4428.firebaseapp.com",
    projectId: "pro-tools-d4428",
    storageBucket: "pro-tools-d4428.firebasestorage.app",
    messagingSenderId: "541932110058",
    appId: "1:541932110058:web:2362c14fff601691315793",
    measurementId: "G-S8R9VV7XS5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const auth = getAuth(app);
export default app;